import { render } from "./Frontend.vue?vue&type=template&id=3e3674bc&scoped=true"
import script from "./Frontend.vue?vue&type=script&lang=js"
export * from "./Frontend.vue?vue&type=script&lang=js"

import "./Frontend.vue?vue&type=style&index=0&id=3e3674bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3674bc"]])

export default __exports__